import { createReducer, on } from '@ngrx/store';
import { initialState } from './api-data.state';
import {
  changeCaptchaResponse,
  changePickupDateHoursPeriodResponse,
  changePickupResponse,
  changePreAuthRequest,
  changePreAuthResponse,
} from './api-data.actions';

export const apiDataReducer = createReducer(
  initialState,
  on(changePreAuthRequest, (state, { preAuthRequest }) => ({
    ...state,
    preAuthRequest: preAuthRequest,
  })),
  on(changeCaptchaResponse, (state, { captchaResponse }) => ({
    ...state,
    captchaResponse: captchaResponse,
  })),
  on(changePreAuthResponse, (state, { preAuthResponse }) => ({
    ...state,
    preAuthResponse: preAuthResponse,
  })),
  on(
    changePickupDateHoursPeriodResponse,
    (state, { pickupDateHoursPeriodResponse }) => ({
      ...state,
      pickupDateHoursPeriodResponse: pickupDateHoursPeriodResponse,
    })
  ),
  on(changePickupResponse, (state, { pickupResponse }) => ({
    ...state,
    pickupResponse: pickupResponse,
  }))
);
